export default {"src":"/_next/static/media/x.a73027d8.svg","height":271,"width":300,"blurWidth":0,"blurHeight":0};